import { render, staticRenderFns } from "./CompanySettings.vue?vue&type=template&id=84b37844&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=js"
export * from "./CompanySettings.vue?vue&type=script&lang=js"
import style0 from "./CompanySettings.vue?vue&type=style&index=0&id=84b37844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b37844",
  null
  
)

export default component.exports